import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalKeyboardDirective } from '../modal-keyboard/modal-keyboard.directive';

@Component({
  selector: 'lib-devices-lifecycle-modal-template',
  standalone: true,
  imports: [CommonModule, ModalKeyboardDirective],
  template: `
    <div class="devices-lifecycle-modal__backdrop" (click)="cancel.emit()">
      <div
        class="devices-lifecycle-modal"
        [class.devices-lifecycle-modal--editable]="editable"
        (click)="$event.stopPropagation()"
        [libModalKeyboard]="true"
        [libModalKeyboardCanSubmit]="canSubmit"
        [libModalKeyboardAutofocus]="autofocus"
        (libModalKeyboardCancel)="cancel.emit()"
        (libModalKeyboardSubmit)="submit.emit()"
      >
        <div class="devices-lifecycle-modal__head">
          <h3>{{ title }}</h3>
          <button type="button" class="devices-lifecycle-modal__close" (click)="cancel.emit()">
            {{ closeText }}
          </button>
        </div>

        @if (hasMeta) {
          <div class="devices-lifecycle-modal__meta">{{ meta }}</div>
        }

        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [`
    .devices-lifecycle-modal__backdrop {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.45);
      display: grid;
      place-items: center;
      z-index: 1000;
    }

    .devices-lifecycle-modal {
      width: min(920px, calc(100vw - 24px));
      background: #fff;
      border-radius: 12px;
      padding: 16px;
      display: grid;
      gap: 10px;
      max-height: calc(100vh - 24px);
      overflow: auto;
    }

    .devices-lifecycle-modal--editable:focus-within {
      border-color: #2563eb;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
    }

    .devices-lifecycle-modal__head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
    }

    .devices-lifecycle-modal__head h3 {
      margin: 0;
    }

    .devices-lifecycle-modal__meta {
      color: #4b5563;
      font-size: 12px;
      white-space: pre-line;
    }

    .devices-lifecycle-modal__close {
      height: 38px;
      border: 1px solid #d1d5db;
      border-radius: 8px;
      background: #fff;
      padding: 0 12px;
      cursor: pointer;
    }
  `],
})
export class DevicesLifecycleModalTemplateComponent {
  @Input() public title = 'Device lifecycle';
  @Input() public closeText = 'Close';
  @Input() public meta = '';
  @Input() public editable = false;
  @Input() public canSubmit = true;
  @Input() public autofocus = true;

  @Output() public readonly cancel = new EventEmitter<void>();
  @Output() public readonly submit = new EventEmitter<void>();

  protected get hasMeta(): boolean {
    return this.meta.trim().length > 0;
  }
}
